import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { MapPin, Phone, Mail, Clock, Instagram, MessageCircle } from 'lucide-react';

const Contact = () => {
  const handleWhatsApp = () => {
    window.open('https://wa.me/33767632259', '_blank');
  };

  const handleCall = () => {
    window.open('tel:+33767632259', '_self');
  };

  const handleEmail = () => {
    window.open('mailto:paulodomingos332@gmail.com', '_self');
  };

  const handleInstagram = () => {
    window.open('https://instagram.com/pablocoiffure', '_blank');
  };

  return (
    <div className="pt-16">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-b from-background to-secondary/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-display font-bold mb-6">
            Contactez <span className="text-gradient">Pablo Coiffure</span>
          </h1>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Nous sommes là pour répondre à toutes vos questions et vous accompagner dans votre transformation. 
            N'hésitez pas à nous contacter !
          </p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Informations de contact */}
          <div className="space-y-8">
            <Card className="card-luxury">
              <CardContent className="p-8">
                <h2 className="text-2xl font-display font-bold mb-6 text-center">
                  Nos coordonnées
                </h2>
                
                <div className="space-y-6">
                  <div className="flex items-start space-x-4">
                    <div className="p-3 bg-primary/10 rounded-full">
                      <MapPin className="h-6 w-6 text-primary" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-lg mb-1">Adresse</h3>
                      <p className="text-muted-foreground">
                        94 Grande Rue de la Guillotière<br />
                        69007 Lyon, France
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="p-3 bg-primary/10 rounded-full">
                      <Phone className="h-6 w-6 text-primary" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-lg mb-1">Téléphone</h3>
                      <p className="text-muted-foreground">+33 7 67 63 22 59</p>
                      <Button
                        onClick={handleCall}
                        variant="outline"
                        size="sm"
                        className="mt-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground"
                      >
                        Appeler maintenant
                      </Button>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="p-3 bg-primary/10 rounded-full">
                      <Mail className="h-6 w-6 text-primary" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-lg mb-1">Email</h3>
                      <p className="text-muted-foreground">paulodomingos332@gmail.com</p>
                      <Button
                        onClick={handleEmail}
                        variant="outline"
                        size="sm"
                        className="mt-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground"
                      >
                        Envoyer un email
                      </Button>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="p-3 bg-primary/10 rounded-full">
                      <Clock className="h-6 w-6 text-primary" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-lg mb-1">Horaires</h3>
                      <p className="text-muted-foreground">
                        Lundi au Samedi<br />
                        <span className="text-primary font-semibold">Ouvert 24h/24</span>
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="p-3 bg-primary/10 rounded-full">
                      <Instagram className="h-6 w-6 text-primary" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-lg mb-1">Instagram</h3>
                      <p className="text-muted-foreground">@pablocoiffure</p>
                      <Button
                        onClick={handleInstagram}
                        variant="outline"
                        size="sm"
                        className="mt-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground"
                      >
                        Suivre sur Instagram
                      </Button>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Contact rapide */}
            <Card className="card-luxury">
              <CardContent className="p-8 text-center">
                <h3 className="text-xl font-display font-bold mb-4">
                  Contact rapide
                </h3>
                <p className="text-muted-foreground mb-6">
                  Pour une réponse immédiate, contactez-nous directement via WhatsApp ou téléphone.
                </p>
                
                <div className="flex flex-col sm:flex-row gap-4">
                  <Button
                    onClick={handleWhatsApp}
                    className="flex-1 bg-green-600 hover:bg-green-700 text-white"
                  >
                    <MessageCircle className="h-5 w-5 mr-2" />
                    WhatsApp
                  </Button>
                  
                  <Button
                    onClick={handleCall}
                    variant="outline"
                    className="flex-1 border-primary text-primary hover:bg-primary hover:text-primary-foreground"
                  >
                    <Phone className="h-5 w-5 mr-2" />
                    Appeler
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Carte et informations supplémentaires */}
          <div className="space-y-8">
            {/* Localisation */}
            <Card className="card-luxury">
              <CardContent className="p-8">
                <h3 className="text-xl font-display font-bold mb-4 text-center">
                  Notre localisation
                </h3>
                
                {/* Placeholder pour la carte - vous pouvez intégrer Google Maps ici */}
                <div className="bg-secondary/50 rounded-lg h-64 flex items-center justify-center mb-4">
                  <div className="text-center">
                    <MapPin className="h-12 w-12 text-primary mx-auto mb-2" />
                    <p className="text-muted-foreground">
                      94 Grande Rue de la Guillotière<br />
                      69007 Lyon
                    </p>
                  </div>
                </div>
                
                <div className="text-center">
                  <Button
                    onClick={() => window.open('https://maps.google.com/?q=94+Grande+Rue+de+la+Guillotière,+69007+Lyon', '_blank')}
                    variant="outline"
                    className="border-primary text-primary hover:bg-primary hover:text-primary-foreground"
                  >
                    Voir sur Google Maps
                  </Button>
                </div>
              </CardContent>
            </Card>

            {/* Transports */}
            <Card className="card-luxury">
              <CardContent className="p-8">
                <h3 className="text-xl font-display font-bold mb-4">
                  Comment nous rejoindre
                </h3>
                
                <div className="space-y-4">
                  <div>
                    <h4 className="font-semibold text-primary mb-2">🚇 Métro</h4>
                    <p className="text-muted-foreground">
                      Ligne A - Arrêt Guillotière Gabriel Péri<br />
                      À 2 minutes à pied du salon
                    </p>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold text-primary mb-2">🚌 Bus</h4>
                    <p className="text-muted-foreground">
                      Lignes 25, 35, C7, C12<br />
                      Arrêt Guillotière Gabriel Péri
                    </p>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold text-primary mb-2">🚗 Voiture</h4>
                    <p className="text-muted-foreground">
                      Parking public à proximité<br />
                      Stationnement payant dans la rue
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* FAQ rapide */}
            <Card className="card-luxury">
              <CardContent className="p-8">
                <h3 className="text-xl font-display font-bold mb-4">
                  Questions fréquentes
                </h3>
                
                <div className="space-y-4">
                  <div>
                    <h4 className="font-semibold mb-1">Faut-il prendre rendez-vous ?</h4>
                    <p className="text-muted-foreground text-sm">
                      Recommandé pour garantir votre créneau, mais nous acceptons aussi les clients sans rendez-vous selon disponibilité.
                    </p>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold mb-1">Quels moyens de paiement acceptez-vous ?</h4>
                    <p className="text-muted-foreground text-sm">
                      Espèces et carte bancaire.
                    </p>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold mb-1">Combien de temps dure une séance de tresses ?</h4>
                    <p className="text-muted-foreground text-sm">
                      Entre 2 et 4 heures selon la complexité de la coiffure souhaitée.
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-primary/10 to-primary-glow/10">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-display font-bold mb-6">
            Prêt à nous <span className="text-gradient">rencontrer</span> ?
          </h2>
          <p className="text-lg text-muted-foreground mb-8">
            N'attendez plus pour découvrir l'excellence de Pablo Coiffure. Contactez-nous dès maintenant !
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/booking"
              className="inline-flex items-center justify-center px-8 py-3 bg-gradient-to-r from-primary to-primary-glow text-primary-foreground font-semibold rounded-lg hover:shadow-xl hover:shadow-primary/30 transform hover:scale-105 transition-all duration-300"
            >
              Prendre rendez-vous
            </a>
            <Button
              onClick={handleWhatsApp}
              variant="outline"
              size="lg"
              className="border-primary text-primary hover:bg-primary hover:text-primary-foreground transform hover:scale-105 transition-all duration-300"
            >
              <MessageCircle className="h-5 w-5 mr-2" />
              WhatsApp
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;